export default {
  namespaced: true,
  state: { deliveryTemplateNo: 0 },
  mutations: {
    SET_DELIVERY_TEMPLATE_NO(state: any, deliveryTemplateNo: number): void {
      state.deliveryTemplateNo = deliveryTemplateNo;
    }
  }
};
